import { reportDateOptionsSlice } from 'store/configuration/report-date-options/slices/report-date-options-slice';

export const configurationReportDateOptionsReducer = reportDateOptionsSlice.reducer;
